(() => {
  const init = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const selectors = [
      '.category-banner--inner',
      '.text-grid--block',
      '.image-text--block',
      '.about-trust__grid > div',
      '.about-trust__cta',
      '.customer-gallery__card',
      '.customer-gallery__cta',
      '.view-doors--content',
      '.view-doors--product',
      '.builder-card--one',
      '.about-doors-overview article',
      '.jmf-craft-standard__intro',
      '.jmf-craft-standard__item',
      '.about-doors-overview__actions',
      '.about-doors-closing > div'
    ];

    const elements = [...document.querySelectorAll(selectors.join(','))];
    if (!elements.length) return;

    document.documentElement.classList.add('jmf-motion-ready');

    elements.forEach((element, index) => {
      element.classList.add('jmf-reveal');
      if (element.matches('.category-banner--inner,.view-doors--content')) {
        element.classList.add('jmf-reveal--soft');
      }
      element.style.setProperty('--jmf-delay', `${180 + Math.min(index % 4, 3) * 140}ms`);
    });

    if (!('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

    /* Two frames ensure the hidden state is painted before revealing,
       making the entrance visible instead of completing before first paint. */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        elements.forEach(element => observer.observe(element));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();